/**
 *Angular module*/
import {Component, ElementRef, EventEmitter, forwardRef, HostListener, Input, Output, ViewChild} from '@angular/core';
/**
 *Pipe*/
import * as moment from 'moment';
/**
 *Shared*/
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NotificationService} from '../../services/notification.service';

@Component({
    selector: 'app-date-picker',
    styleUrls: ['./date-picker.component.scss'],
    template: `
        <div class="input-group" [ngClass]="{'date-expansion':isEnabled }">
            <input class="form-control" placeholder="yyyy-mm-dd" [name]="name" [(ngModel)]="model" (ngModelChange)="onModelChange()"
                   [minDate]="minDate"
                   ngbDatepicker #dp="ngbDatepicker" autoClose="false" [footerTemplate]="footerTemplate" readonly>
            <div class="input-group-append" (click)="dp.open();isEnabled = true"><span class="input-group-text"><i class="icon-regular i-Calendar-4" aria-hidden="true"></i></span></div>
        </div>
        <ng-template #footerTemplate>
            <hr class="my-0">
            <button class="btn btn-primary btn-sm m-2 float-left" (click)="model = today;onModelChange();; dp.close();isEnabled = false">Today</button>
            <button type="button" class="btn btn-outline-danger btn-sm m-2 float-right" (click)="dp.close();isEnabled = false"><span class="fa fa-times"></span></button>
        </ng-template>`,
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DatePickerComponent), multi: true}]
})
export class DatePickerComponent implements ControlValueAccessor {
    today = {year: moment().get('year'), month: moment().get('month') + 1, day: moment().get('date') + 1};
    @Input() name = '';
    @Input() model: any = this.today;
    @Input() range: string;
    @Input() disablePastDates = false;
    isEnabled = false;
    minDate = undefined;

    @Output() setDate: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('dp') dp;
    private propagateChange: any = () => {
    };

    constructor(private _eref: ElementRef, public notificationService: NotificationService) {
        setTimeout(() => {
            if (this.disablePastDates) {
                this.minDate = this.today;
            }
        }, 600);
    }

    @HostListener('document:click', ['$event'])
    onClick(event: any) {
        if (this._eref.nativeElement.contains(event.target)) {
            return true;
        }
    }

    onModelChange() {
        this.propagateChange(this.model);
        this.setDate.emit(moment().year(this.model.year).month(this.model.month - 1).date(this.model.day).format('YYYY-MM-DD'));
    }

    writeValue(value: string) {
        const date: { date: Number, months: Number, years: Number } | null
            = value == null || value == '' || value == undefined
            ? null
            : moment(value).add(1, 'months').toObject();

        this.model = date != null
            ? {day: Number(date.date), month: Number(date.months), year: Number(date.years)}
            : null;
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {
    }
}
